import classnames from 'classnames';
import React, { HTMLProps, ReactNode } from 'react';
import './Badge.scss';

export interface BadgeProps extends Omit<HTMLProps<HTMLSpanElement>, 'size'> {
  className?: string;
  color?: 'primary' | 'secondary' | 'muted' | 'default';
  size?: 'small' | 'large';
  variant?: 'fill' | 'dot';
  visible?: boolean;
  children?: ReactNode;
}
export const Badge = ({
  className,
  color = 'primary',
  size,
  variant,
  visible = true,
  ...props
}: BadgeProps) => {
  const spanClassName = classnames('badge', className, {
    [`badge-color-${color}`]: color,
    [`badge-size-${size}`]: size,
    [`badge-variant-${variant}`]: variant,
    'badge-invisible': !visible,
  });
  return <span className={spanClassName} {...props} />;
};
